import { render, staticRenderFns } from "./DocumentSettings.vue?vue&type=template&id=01d4bec2&scoped=true&"
import script from "./DocumentSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentSettings.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSettings.vue?vue&type=style&index=0&id=01d4bec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4bec2",
  null
  
)

export default component.exports